import React from 'react';

import { strings } from '../../../localization';
import { accountHasBilling } from '../../common/billing';
import EditBillingModal from './editBillingModal';

export default class BillingInfo extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            editBillingModalOpen: false,
            editBillingConfirmationMessage: null,
            editBillingErrorMessage: null,
        };
    }

    openEditBillingModal = (e) => {

        if (e) e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            editBillingModalOpen: true
        });
    }

    closeEditBillingModal = (e) => {

        if (e.target) e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        var confirmationMessage = null;
        var errorMessage = null;
        if (e.Payload) {
            var payload = JSON.parse(e.Payload);
            if (payload && payload.status === 'SUCCESS') {
                confirmationMessage = payload.message //TODO LOCALIZATION BILLING
            } else if (payload && payload.status === 'ERROR') {
                errorMessage = payload.message //TODO LOCALIZATION BILLING
            }
        }

        this.setState({
            editBillingModalOpen: false,
            editBillingConfirmationMessage: confirmationMessage,
            editBillingErrorMessage: errorMessage
        });
    }

    render() {

        var ad = this.props.accountDetails;
        var bi = ad ? ad.billingInfo : null;

        if(!accountHasBilling(ad))
        {
            // Channel MVP or other non-billing account type
            // Nothing to render for billing
            return null;
        }

        var buttonDisabled = window.recurly ? false : true;
        const canEditBilling = this.props.canEditBilling;

        let confirmationMessage = null;
        if(this.state.editBillingConfirmationMessage) {
            confirmationMessage = <p className="success-message"><i className="material-icons">check_circle</i>{this.state.editBillingConfirmationMessage}</p>;
        } else if (this.state.editBillingErrorMessage) {
            confirmationMessage = <p className="error-message"><i className="material-icons">error_outline</i>{this.state.editBillingErrorMessage}</p>;
        }

        if (!bi) {
            return (
                <div className="col-12 billing-section">
                    <p>{strings.formatString(strings.no_billing_info_message)}</p>
                    <div className="col-12 button-row">
                        {canEditBilling ? 
                            buttonDisabled ?
                                <button className="btn" onClick={this.openEditBillingModal} disabled title="Enable Javascript to edit billing information"><i className="material-icons">edit</i>{strings.billing_action_edit_payment_information}</button>
                            :
                                <button className="btn" onClick={this.openEditBillingModal}><i className="material-icons">edit</i>{strings.billing_action_edit_payment_information}</button>
                        :
                            null
                        }
                        <EditBillingModal
                            {...this.props}
                            isOpen={this.state.editBillingModalOpen}
                            closeEditBillingModal={this.closeEditBillingModal} />
                    </div>
                </div>
            )
        } else
            return (
                <div className="col-12 billing-section">
                    <div className="row">
                        <div className="col-12">
                            <h3><i className="material-icons">payment</i>{strings.billing_payment_information_title}</h3>
                        </div>

                        <div className="col-12 col-sm-6">

                            <h4>{strings.billing_credit_card_information_title}</h4>

                            <div className="row">
                                <div className="col-12">
                                    <label htmlFor="">{strings.billing_credit_card_type_number_label}</label>
                                    <p>{bi.cardType} - XXXX XXXX XXXX {bi.lastFour}</p>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="">{strings.billing_expiry_date_label}</label>
                                    <p>{bi.month}/{bi.year}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_first_name_label}</label>
                                    <p>{bi.firstName}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_last_name_label}</label>
                                    <p>{bi.lastName}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-6">

                            <h4>{strings.billing_billing_address_title}</h4>

                            <div className="row">
                                <div className="col-12">
                                    <label htmlFor="">{strings.billing_address_line_1_label}</label>
                                    <p>{bi.address1}</p>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="">{strings.billing_address_line_2_label}</label>
                                    <p>{bi.address2 && bi.address2 !== '' ? bi.address2 : '-'}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_address_city_label}</label>
                                    <p>{bi.city}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_zip_postal_code_label}</label>
                                    <p>{bi.zip}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_country_label}</label>
                                    <p>{bi.country}</p>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="">{strings.billing_state_province_label}</label>
                                    <p>{bi.state}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 button-row">
                            {canEditBilling ?
                                buttonDisabled ? 
                                    <button className="btn" onClick={this.openEditBillingModal} disabled title="Enable Javascript to edit billing information"><i className="material-icons">edit</i>{strings.billing_action_edit_payment_information}</button>
                                :
                                    <button className="btn" onClick={this.openEditBillingModal}><i className="material-icons">edit</i>{strings.billing_action_edit_payment_information}</button>
                            : 
                                null
                            }
                            <EditBillingModal
                                {...this.props}
                                isOpen={this.state.editBillingModalOpen}
                                closeEditBillingModal={this.closeEditBillingModal} />
                            {confirmationMessage}
                        </div>
                    </div>
                </div>
            );
    }
}
